import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "AIR MAX 90 SE ‘ BLACK / SCREAM GREEN ‘",
    description:
      "Max Air changed the game in ’87. Now, we honour its emerald anniversary (35 years!) with the Nike Air Max 90 SE. Emerald graphics and colours highlight this big landmark, while its classic Waffle outsole and exposed Air cushioning keep you living the legacy in comfort",
    image: "https://superkicks.in/wp-content/uploads/2022/03/1-4-850x850.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/03/1-4-850x850.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/2-3-850x850.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/3-4-850x850.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/4-4-850x850.jpg",
    ],
    price: "11895",
    brand: "Nike",
    inStock: true,
    fastDelivery: false,
    ratings: 3.2,
  },
  {
    _id: uuid(),
    name: "AIR FORCE 1 07′ LV8 ‘ PURPLE CANYON ‘",
    description:
      "The radiance lives on in the Nike Air Force 1 ’07, the b-ball OG that puts a fresh spin on what you know best: stitched overlays, bold colors and the perfect amount of hoops style to make heads turn. The patch on the back adds retro inspiration, while the insole graphic delivers the perfect amount of wild.",
    image: "https://superkicks.in/wp-content/uploads/2022/03/1-26-850x816.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/03/1-26-850x816.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/2-25-850x816.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/3-26-850x816.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/4-26-850x816.jpg",
    ],
    price: "9695",
    brand: "Nike",
    inStock: true,
    fastDelivery: false,
    ratings: 4,
  },
  {
    _id: uuid(),
    name: "ZOOM FREAK 3 ‘ BLACK / UNIVERSITY RED ‘",
    description:
      "Giannis is an athlete of freakish power and incredible range. His ability to play any position make him difficult to guard and nearly impossible to stop. The Zoom Freak 3 helps Giannis create space with his massive strides and misdirecting Euro-step. The molded midfoot strap and external overlay provide side-to-side stability when he’s powering to the rim, while the multidirectional traction helps him stay in control.",
    image:
      "https://superkicks.in/wp-content/uploads/2022/02/1-4-12-850x850.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/02/1-4-12-850x850.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/2-1-36-850x850.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/3-85-850x850.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/4-83-850x850.jpg",
    ],
    price: "10895",
    brand: "Nike",
    inStock: true,
    fastDelivery: false,
    ratings: 4.5,
  },
  {
    _id: uuid(),
    name: "KYRIE 6 EP",
    description:
      "Designed for Kyrie Irving’s creative and unpredictable game, the Kyrie 6 focuses on comfort, control and energy return to help him go fast and stay fresh. Bouncy cushioning is paired with soft yet supportive foam for responsiveness and smooth heel-to-toe transitions, while the midfoot strap and plush, padded collar lock him in and help keep him a step ahead of the competition.",
    image: "https://superkicks.in/wp-content/uploads/2020/03/kyb.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2020/03/kyb.jpg",
      "https://superkicks.in/wp-content/uploads/2020/03/kyb-2.jpg",
      "https://superkicks.in/wp-content/uploads/2020/03/kyb-4.jpg",
      "https://superkicks.in/wp-content/uploads/2020/03/kyb-3.jpg",
    ],
    price: "10995",
    brand: "Nike",
    inStock: true,
    fastDelivery: true,
    ratings: 2.5,
  },

  {
    _id: uuid(),
    name: "AIR MAX 2090",
    description:
      "A FUTURISTIC LEAP FORWARD. Bring the past into the future with the Nike Air Max 2090. Inspired by the iconic Air Max 90, this shoe features Nike Air cushioning underfoot that adds unparalleled comfort, while transparent mesh on the upper blend with timeless OG features for an edgy, modernised look.",
    image: "https://superkicks.in/wp-content/uploads/2020/07/2090w-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2020/07/2090w-1.jpg",
      "https://superkicks.in/wp-content/uploads/2020/07/2090w-2-1.jpg",
      "https://superkicks.in/wp-content/uploads/2020/07/2090w-3-1.jpg",
      "https://superkicks.in/wp-content/uploads/2020/07/2090w-4-1.jpg",
    ],
    price: "11995",
    brand: "Nike",
    inStock: true,
    fastDelivery: false,
    ratings: 4,
  },
  {
    _id: uuid(),
    name: "JORDAN “WHY NOT” ZER0.3 BLACK CEMENT",
    description:
      "One of the game’s fiercest competitors, triple-double dynamo Russell Westbrook has the motor, muscle and mentality to match his fearlessnessÄîwith the stats to back it up. Built to hold up on outdoor courts, the Jordan “Why Not?” Zer0.3 PF is fine-tuned for players like Russ, who beat opponents with linear speed and aggressiveness.",
    image: "https://superkicks.in/wp-content/uploads/2020/06/Why-not-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2020/07/2090w-1.jpg",
      "https://superkicks.in/wp-content/uploads/2020/06/Why-not-2.jpg",
      "https://superkicks.in/wp-content/uploads/2020/06/Why-not-4.jpg",
      "https://superkicks.in/wp-content/uploads/2020/06/Why-not-6.jpg",
    ],
    price: "10995",
    brand: "Air Jordan",
    inStock: true,
    fastDelivery: false,
    ratings: 4.4,
  },
  {
    _id: uuid(),
    name: "AIR JORDAN 13 ‘ DEL SOL ‘",
    description:
      "When the sun beams down, life can feel a bit brighter and lighter. Passing along those good rays, the ‘Del Sol’ Air Jordan 13 features a simple makeup with an original look and packaging. A Black outsole sets the stage for a premium White quilted leather upper accented by rich, colourful hits of ‘Del Sol’ suede. Bask in the sun and shine bright this spring with this newest Air Jordan 13 colourway.",
    image: "https://superkicks.in/wp-content/uploads/2022/03/1-20.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/03/1-20.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/2-19.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/3-20.jpg",
      "https://superkicks.in/wp-content/uploads/2022/03/4-20.jpg",
    ],
    price: "15995",
    brand: "Air Jordan",
    inStock: true,
    fastDelivery: false,
    ratings: 3.4,
  },
  {
    _id: uuid(),
    name: "JORDAN WHY NOT? Zer0.4 PF HYPER PINK‘",
    description:
      "Speed is Russell Westbrook’s not-so-secret weapon. He continually out-hustles the competition, building momentum and muscling his way onto the highlight reel. Cue the Jordan Why Not? Zer0.4, the first to feature double-stacked Zoom in the forefoot. It’s an extra-responsive cushioning system that’s designed to help him transform speed into force and focus his attack.",
    image: "https://superkicks.in/wp-content/uploads/2021/07/CQ4231-102-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2021/07/CQ4231-102-1.jpg",
      "https://superkicks.in/wp-content/uploads/2021/07/CQ4231-102-2.jpg",
      "https://superkicks.in/wp-content/uploads/2021/07/CQ4231-102-3.jpg",
      "https://superkicks.in/wp-content/uploads/2021/07/CQ4231-102-4.jpg",
    ],
    price: "11495",
    brand: "Air Jordan",
    inStock: false,
    fastDelivery: true,
    ratings: 2.4,
  },
  {
    _id: uuid(),
    name: "FORUM LOW X SOUTH PARK ‘ CARTMAN ‘",
    description:
      "A big-boned iteration of the adidas Forum Low, this lowtop features an elaborate red leather upper with yellow and turquoise details that refer to Cartman’s headgear, as well as three side bands in black. Additional branding on the tongue and strap, as well as a white sole and a black outsole, complete the makeover. This pair comes with co-branded insoles and special-edition packaging.",
    image: "https://superkicks.in/wp-content/uploads/2022/01/1-4-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/01/1-4-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/01/2-5-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/01/2-4-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/01/4-4-1.jpg",
    ],
    price: "9999",
    brand: "Adidas",
    inStock: true,
    fastDelivery: true,
    ratings: 4.4,
  },
  {
    _id: uuid(),
    name: "NMD_R1 ‘ CORE BLACK ‘",
    description:
      "Stand out in the concrete jungle. Inspired by an acclaimed ’80s runner from the adidas archives, these NMD_R1 Shoes provide a sock-like fit with a stretchy and supportive knit upper. Energy-returning Boost cushioning provides all-day comfort, and midsole plugs on the sides stand out as the recognizable mark of iconic NMD style. And if that isn’t enough to draw some attention, the chic colors sure will.",
    image: "https://superkicks.in/wp-content/uploads/2022/02/1-20.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/02/1-20.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/2-17-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/3-17-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/4-16-1.jpg",
    ],
    price: "12999",
    brand: "Adidas",
    inStock: true,
    fastDelivery: true,
    ratings: 4.1,
  },
  {
    _id: uuid(),
    name: "TORSION X CORE BLACK",
    description:
      "The next generation of streetwear innovation reaches new levels. These shoes update the retro-tech Torsion System with Torsion X, an X-shaped support bar that lets your foot move naturally for easy comfort. Responsive Boost cushioning adds energy return.",
    image:
      "https://superkicks.in/wp-content/uploads/2020/03/torsionboostblack-1.jpg.webp",
    images: [
      "https://superkicks.in/wp-content/uploads/2020/03/torsionboostblack-1.jpg.webp",
      "https://superkicks.in/wp-content/uploads/2020/03/torsionboostblack-2.jpg.webp",
      "https://superkicks.in/wp-content/uploads/2020/03/torsionboostblack-3.jpg.webp",
    ],
    price: "17999",
    brand: "Adidas",
    inStock: true,
    fastDelivery: false,
    ratings: 2.1,
  },
  {
    _id: uuid(),
    name: "RETROPY F2 BLUE",
    description:
      "You like to be one step ahead. Blending retro vibes with modern design, these adidas Retropy F2 Shoes are right there with you. Rooted in ’80s running style, they show off a layered material-mix upper. The sleek shape and thick EVA midsole make them ideal for today.",
    image: "https://superkicks.in/wp-content/uploads/2022/01/1-9-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/01/1-9-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/01/2-5-2.jpg",
      "https://superkicks.in/wp-content/uploads/2022/01/3-6-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/01/4-5-2.jpg",
    ],
    price: "8999",
    brand: "Adidas",
    inStock: true,
    fastDelivery: false,
    ratings: 4,
  },
  {
    _id: uuid(),
    name: "FORUM MID WHITE / BLUE",
    description:
      "Let’s take a moment to honor an icon. Is it the gravity-defying B-ball legend from the ’80s? Or perhaps the status shoe that adorned the feet of rappers? Both, in fact. The adidas Forum shoes have dominated the hardwood and the streets, and they’re back in a mid top version to take your moves to the next level. Slip into the unmistakable style, now in luxurious coated leather, and flaunt that pure class.",
    image: "https://superkicks.in/wp-content/uploads/2022/02/1-2-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2022/02/1-2-1.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/2-24.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/3-23.jpg",
      "https://superkicks.in/wp-content/uploads/2022/02/4-23.jpg",
    ],
    price: "9999",
    brand: "Adidas",
    inStock: true,
    fastDelivery: true,
    ratings: 3.5,
  },
  {
    _id: uuid(),
    name: "BUTTER GOODS BASKET VINTAGE",
    description:
      "School friends Garth Mariano and Matt Evans launched the Butter Goods label in 2008 as a way to showcase their custom graphics inspired by their love of jazz, ’90s hip hop and funk & soul. For our first collaboration, we’ve pulled some of our skate classics from the archives and mixed it up with the elements drawn from the skate culture of the early 2000s. This is authentic street style at its finest.",
    image: "https://superkicks.in/wp-content/uploads/2021/09/Butter1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2021/09/Butter1.jpg",
      "https://superkicks.in/wp-content/uploads/2021/09/Butter2.jpg",
      "https://superkicks.in/wp-content/uploads/2021/09/Butter3.jpg",
      "https://superkicks.in/wp-content/uploads/2021/09/Butter4.jpg",
    ],
    price: "5249",
    brand: "Puma",
    inStock: true,
    fastDelivery: false,
    ratings: 4,
  },
  {
    _id: uuid(),
    name: "RUDOLF DASSLER LEGACY SUEDE MID VTG",
    description:
      "Since its release in 1968, the Suede has been the footwear of icons, finding new followers with every generation. The VTG edition is faithful to the original, channelling pure retro vibes. It’s part of the Rudolf Dassler Legacy collection, and the Laundry Boys range takes inspiration from PUMA’s founder and his humble beginnings as one of his mother’s “laundry boys”. The stand-out laundry label detail at the tongue is a nod to his story, while supreme street style is afforded by the premium suede upper, the vintage mid-boot silhouette and the on-trend metallic trinket detail.",
    image: "https://superkicks.in/wp-content/uploads/2021/08/38117701-1.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2021/08/38117701-1.jpg",
      "https://superkicks.in/wp-content/uploads/2021/08/38117701-1.jpg",
      "https://superkicks.in/wp-content/uploads/2021/08/38117701-2.jpg",
      "https://superkicks.in/wp-content/uploads/2021/08/38117701-3.jpg",
    ],
    price: "7499",
    brand: "Puma",
    inStock: true,
    fastDelivery: true,
    ratings: 3.8,
  },
  {
    _id: uuid(),
    name: "RS-2K INTERNET EXPLORING",
    description:
      "Experience a paradigm shift in athletic technology. Our RS-2K Internet Exploring is delves into today’s digital narratives in physical form. The RS-2K family of design represents a true renaissance of style and innovation in sportswear, featuring bright splashes of colour and futuristic shapes to deliver high-impact designs that redefine the market.",
    image: "https://superkicks.in/wp-content/uploads/2021/06/01-17.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2021/06/01-17.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/02-17.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/03-17.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/04-16.jpg",
    ],
    price: "6999",
    brand: "Puma",
    inStock: true,
    fastDelivery: false,
    ratings: 4.8,
  },
  {
    _id: uuid(),
    name: "FUTURE RIDER TWOFOLD BLACK",
    description:
      "Step out in this iconic staple from the PUMA archives, outfitted with fresh colourblocking and lines for the fashion savvy. Our Future Rider Twofold Trainers come equipped with an IMEVA midsole for superior rebound and comfort.",
    image: "https://superkicks.in/wp-content/uploads/2021/06/01-19.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2021/06/01-19.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/02-20.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/03-20.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/04-19.jpg",
    ],
    price: "5599",
    brand: "Puma",
    inStock: true,
    fastDelivery: true,
    ratings: 4.2,
  },
  {
    _id: uuid(),
    name: "MIRAGE MOX VISION BLUE ATOLL",
    description:
      "The Mirage Mox collection takes design cues from a 1970s pair of PUMA running shoes and transforms them with a textural contrast and funky futuristic elements. Inspired by illusions and the space between what’s real and otherworldly, it’s ready for new realities. With bold pops of colour, the Vision iteration features premium materials for a sophisticated silhouette that will have you rocking retro with cool confidence.",
    image: "https://superkicks.in/wp-content/uploads/2021/06/01-22.jpg",
    images: [
      "https://superkicks.in/wp-content/uploads/2021/06/01-22.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/02-23.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/03-23.jpg",
      "https://superkicks.in/wp-content/uploads/2021/06/04-22.jpg",
    ],
    price: "8599",
    brand: "Puma",
    inStock: false,
    fastDelivery: false,
    ratings: 3.5,
  },
];
